import { ComponentType } from 'react'

export function overwriteHocDisplayName(
  WrappedComponent: ComponentType<any>,
  OuterComponent: ComponentType<any>,
  prefix: string
) {
  const wrappedComponentName = extractComponentName(WrappedComponent)
  OuterComponent.displayName = composeHocDisplayName(prefix, wrappedComponentName)
}

export const composeHocDisplayName = (wrapperName: string, componentName: string) => {
  return `${wrapperName}(${componentName})`
}

export const extractComponentName = (component: ComponentType<any>) => {
  return component.displayName || component.name || 'Unknown component'
}
